import { Component, Input, OnInit } from '@angular/core';

import { ThumbnailKinds, Template } from '@site-mate/dashpivot-shared-library';

import { UserService } from 'app/user/user.service';

@Component({
  selector: 'cc-form-card',
  templateUrl: 'form-card.component.html',
  styleUrls: ['form-card.component.scss'],
})
export class FormCardComponent implements OnInit {
  @Input() form;
  @Input() template: Template;
  initial = '';
  thumbnailFields;

  ngOnInit(): void {
    const firstName = this.form.createdBy ? this.form.createdBy.firstName : '';
    const lastName = this.form.createdBy ? this.form.createdBy.lastName : '';
    this.initial = UserService.getInitial(firstName, lastName);
    this.thumbnailFields = this.getThumbnails(this.form);
  }

  private getThumbnails(form) {
    return this.template.displayFormThumbnailBy
      .map((thumbFieldId) => {
        let field = form.items.find((item) => item._id === thumbFieldId);

        if (!field && (thumbFieldId as ThumbnailKinds) === ThumbnailKinds.CreatedBy) {
          field = {
            kind: thumbFieldId,
            createdByWeb: form[thumbFieldId],
          };
        } else if (!field && form[thumbFieldId]) {
          field = { kind: thumbFieldId, content: form[thumbFieldId] };
        }

        return field;
      })
      .filter(Boolean);
  }

  getInitialStyle() {
    return UserService.getInitialStyle(this.initial);
  }
}
